import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    padding: [theme.spacing(3), 0, theme.spacing(7)],
    [theme.breakpoints.up('mobile')]: {
      maxWidth: 418,
    },
  },
  formGroup: {
    marginBottom: 4,
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(2),
    },
  },
  field: {
    width: '100%',
    marginBottom: theme.spacing(2),
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  button: {
    margin: [12, 0],
    borderColor: theme.palette.colors.teal,
    [theme.breakpoints.up('mobile')]: {
      margin: 0,
      width: 197,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/ResetPassword/components/ResetPasswordForm/useStyles.js